exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-wrapper.product-IM_HOLIDAY .app-body .app-content {\n  color: #D9D9D6;\n  background-color: #382F2D;\n  border-radius: 6px;\n}\n.app-wrapper.product-DIE_TO_FLY .app-body .app-content {\n  color: #D9D9D6;\n  background-color: #EF3340;\n  border-radius: 6px;\n}\n", ""]);

// exports
